<template>
  <div v-show="visible" class="filterDialog" show-cancel-button>
    <div class="dialog_content">
      <div v-for="(item, index) in columns" :key="item.key">
        <div v-if="item.type === 'dialog'">
          <div class="tit">{{ item.tit }}</div>
          <div class="content flex">
            <div v-if="Array.isArray(form[item.key])" class="flex flex-wrap">
              <van-button
                class="active"
                v-for="(el, i) in form[item.showKey]"
                @click="removeValue(item, i)"
                >{{ el }}</van-button
              >
            </div>
            <div v-else>
              <van-button
                class="active"
                v-if="form[item.key]"
                @click="removeValue(item)"
                >{{ form[item.showKey] }}</van-button
              >
            </div>
            <van-button @click="showDialog(item)">选择</van-button>
          </div>
        </div>
        <div v-else>
          <div class="tit">
            {{ item.tit }}
          </div>
          <div class="content">
            <van-button
              v-for="(el, i) in item.list"
              @click="setValue(item, el, i)"
              :class="{ active: form[item.key] === el.value }"
              >{{ el.label }}</van-button
            >
          </div>
        </div>
      </div>
      <ProductSelect
        type="order"
        :scId="this.form.scId"
        :visible="showProductSelect"
        @confirm="onSelectProductConfirm"
      ></ProductSelect>
      <StockSelect
        :visible="stockSelectVisible"
        @confirm="stockSelectConfirm"
      ></StockSelect>
      <SupplierSelect
        :visible="supplierSelectVisible"
        @confirm="supplierSelectConfirm"
      ></SupplierSelect>
      <slot name="content"></slot>
    </div>
    <slot name="footer">
      <div class="dialog_footer">
        <van-button @click="close">取消</van-button>
        <van-button @click="confirm" type="primary">确定</van-button>
      </div>
    </slot>
  </div>
</template>
<script>
import ProductSelect from "@/components/productSelect.vue";
import StockSelect from "@/components/stockSelect.vue";
import SupplierSelect from "@/components/supplierSelect.vue";

export default {
  name: "index",
  props: {
    visible: false,
  },
  components: {
    ProductSelect,
    StockSelect,
    SupplierSelect,
  },
  data() {
    return {
      supplierSelectVisible: false,
      stockSelectVisible: false,
      showProductSelect: false,
      show: false,
      form: {
        timeRangeType: "",
        status: "",
        scId: "",
        supplierId: "",
        productId: "",
      },
      columns: [
        {
          tit: "提交日期",
          key: "timeRangeType",
          list: [
            { label: "最近三天", value: "LAST_3_DAYS" },
            { label: "最近一周", value: "LAST_7_DAYS" },
            { label: "最近一月", value: "LAST_30_DAYS" },
            { label: "今日", value: "TODAY" },
            { label: "本周", value: "THIS_WEEK" },
            { label: "本月", value: "THIS_MONTH" },
            { label: "上月", value: "LAST_MONTH" },
            { label: "本季", value: "THIS_QUARTER" },
            { label: "上季", value: "LAST_QUARTER" },
          ],
        },
        {
          tit: "状态",
          key: "status",
          list: [
            { label: "全部", value: "" },
            { label: "待审核", value: "0" },
            { label: "审核通过", value: "3" },
            { label: "审核拒绝", value: "6" },
          ],
        },
        {
          tit: "仓库",
          key: "scId",
          showKey: "scName",
          type: "dialog",
          visible: "stockSelectVisible",
          click: "stockSelectConfirm",
        },
        {
          tit: "供应商",
          key: "supplierId",
          showKey: "supplierName",
          type: "dialog",
          visible: "supplierSelectVisible",
        },
        {
          tit: "商品",
          key: "productId",
          showKey: "productName",
          type: "dialog",
          visible: "showProductSelect",
          require: "scId",
          requireText: "请先选择仓库 ",
        },
      ],
    };
  },
  watch: {
    visible(newVal, oldVal) {
      this.show = newVal;
    },
    form: {
      handler(newVal, oldVal) {},
      deep: true,
      immediate: true,
    },
  },
  created() {},
  mounted() {
    this.columns.forEach((item) => {
      if (item.type !== "dialog") {
        this.form[item.key] = item.list[0].value;
      }
    });
  },
  methods: {
    removeValue(item, i) {
      if (i !== undefined) {
        this.form[item.key].splice(i, 1);
        this.form[item.showKey].splice(i, 1);
      } else {
        this.$set(this.form, item.key, "");
        this.$set(this.form, item.showKey, "");
      }
    },
    showDialog(item) {
      if (item.require) {
        if (!this.form[item.require]) {
          this.$toast(item.requireText);
          return;
        }
      }
      this[item.visible] = true;
    },
    setValue(item, el) {
      if (this.form[item.key] === el.value) {
        this.removeValue(item);
        return;
      }
      this.$set(this.form, item.key, el.value);

      //   this.$emit("change", this.form);
    },
    close() {
      this.$emit("close");
    },
    confirm() {
      this.$emit("confirm", this.form);
    },
    stockSelectConfirm(row) {
      if (Object.keys(row).length === 0) {
        this.stockSelectVisible = false;
        return;
      }
      this.stockSelectVisible = false;
      this.form.scName = row.name;
      this.form.scId = row.id;
    },
    supplierSelectConfirm(row) {
      if (Object.keys(row).length === 0) {
        this.supplierSelectVisible = false;
        return;
      }
      this.supplierSelectVisible = false;
      this.form.supplierName = row.name;
      this.form.supplierId = row.id;
    },
    onSelectProductConfirm(row) {
      if (this.showProductSelect) {
        this.showProductSelect = false;
      }
      
      if (row.length) {
        row.forEach((el) => {
          this.form["productId"]=el.productId;
          this.form["productName"]=el.productName
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.filterDialog {
  background-color: #757575;
  z-index: 1000;
  position: fixed;
  top: 46px;
  left: 0;
  transform: translate(0, 0);
  width: 100vw;
  height: 100%;
  overflow: hidden;
  border-radius: 0px;
  font-size: 14px;
}
.dialog_content {
  padding: 13px 10px 10px 10px;
  height: calc(100% - 200px);
  overflow-y: auto;
  background-color: #fff;
  .tit {
    color: #555;
  }
  .content {
    width: 100%;
    overflow: hidden;
    flex-wrap: wrap;
    ::v-deep .van-button__text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .van-button {
      border-radius: 5px;
      margin: 5px;
      background-color: #fff;
      color: #000;
      min-width: 80px;
      max-width: 150px;
    }
    .van-button.active {
      background-color: #4c9673;
      color: #fff;
    }
  }
}
.dialog_footer {
  width: 100%;
  .van-button {
    width: 50%;
  }
}
</style>
